export enum Types {
  INITIALISATION_COMPLETED = 'LaunchDarkly:InitialisationCompleted',
  INITIALISATION_FAILED = 'LaunchDarkly:InitialisationFailed',
  CLEAR = 'LaunchDarkly:Clear',
  KEY_REQUESTED = 'LaunchDarkly:Requested',
  KEY_STARTED = 'LaunchDarkly:Started',
  KEY_COMPLETED = 'LaunchDarkly:Completed',
  KEY_FAILED = 'LaunchDarkly:Failed',
}

interface EmptyAction {
  type: Types.INITIALISATION_COMPLETED;
}

interface FailedInitialisationAction {
  type: Types.INITIALISATION_FAILED;
  payload: {
    error: string;
  };
}

export interface ActionWithKey {
  type: Types.KEY_REQUESTED | Types.KEY_STARTED;
  payload: {
    key: string;
  };
}

interface CompletedAction {
  type: Types.KEY_COMPLETED;
  payload: {
    key: string;
    allowed: boolean;
  };
}

interface FailedAction {
  type: Types.KEY_FAILED;
  payload: {
    key: string;
    error: string;
  };
}

interface ClearAction {
  type: Types.CLEAR;
}

export type Action =
  | EmptyAction
  | FailedInitialisationAction
  | ActionWithKey
  | CompletedAction
  | FailedAction
  | ClearAction;

export const Actions = {
  completeInitialisation: (): EmptyAction => ({ type: Types.INITIALISATION_COMPLETED }),
  failInitialisation: (error: string): FailedInitialisationAction => ({
    type: Types.INITIALISATION_FAILED,
    payload: {
      error,
    },
  }),
  requestKey: (key: string): ActionWithKey => ({ type: Types.KEY_REQUESTED, payload: { key } }),
  startKeyFetch: (key: string): ActionWithKey => ({ type: Types.KEY_STARTED, payload: { key } }),
  completeKeyFetch: (key: string, allowed: boolean): CompletedAction => ({
    type: Types.KEY_COMPLETED,
    payload: {
      key,
      allowed,
    },
  }),
  failKeyFetch: (key: string, error: string): FailedAction => ({
    type: Types.KEY_FAILED,
    payload: { key, error },
  }),
  clear: (): ClearAction => ({ type: Types.CLEAR }),
};
